export const splitNewlineList = (value: string | null | undefined): string[] =>
  value ? value.split("\n") : [];
